import { Button, Table } from "antd";
import { useEffect, useState } from "react";

const ProfitMarginTable = ({ profitMargin }) => {
  const [data, setData] = useState({});
  const [showAll, setShowAll] = useState(false); // State to manage view mode

  useEffect(() => {
    // Ensure profitMargin is an object and set data accordingly
    if (typeof profitMargin === 'object' && profitMargin !== null) {
      setData(profitMargin?.profitMargin);
    } else {
      setData({});
    }
  }, [data]); // Ensure data updates when profitMargin changes

  console.log(data)

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: () => <span>{data?.name}</span>, // Access directly from data
    },
    {
      title: "Maximize Profit",
      dataIndex: "maximizeProfit",
      render: () => <span>{data?.maximizeProfit}</span>, // Example render for amount
    },
    {
      title: "Minimum Profit",
      dataIndex: "minimumProfit",
      render: () => <span>{data?.minimumProfit}</span>, // Example render for description
    },
  ];

  // No need for displayData in this case, as you directly use `data`

  return (
    <div className="col-md-12 d-flex">
      <div className="card card-table flex-fill">
        <div className="card-header">
          <h3 className="card-title mb-0">Profit Margin</h3>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <Table
              dataSource={[data]} // Convert data object to an array for Table dataSource
              columns={columns}
              pagination={false}
              // rowKey={(record) => record.id || 1} // Use rowKey for unique identification
            />
          </div>
        </div>
        <div className="card-footer">
          {/* No need for the "View All" button as there's only one item */}
        </div>
      </div>
    </div>
  );
};

export default ProfitMarginTable;
